<twc-card [ngClass]="{disabled: disabled}">
    <twc-card-content>
        <twc-list>
            <twc-list-item *ngFor="let item of pagedItems" (click)="toggleSelect(item)"
                [attr.disabled]="item.isDisabled" class="cw-text-overflow-ellipsis"
                [ngClass]="{ 'item-selected': item.isSelected, 'list-item-disabled': item.isDisabled}">
                <div class="twc-list-item-col-1" [ngClass]="{'list-item-col1-disabled': item.isDisabled}">{{item.title |
                    translate}}</div>
            </twc-list-item>
        </twc-list>
    </twc-card-content>
</twc-card>
<twc-paginator cwHidePaginatorControl class="twc-mt-2" [length]="disabled ? 0 : items.length" [pageSize]="pageSize"
    [pageSizesList]="[pageSize]" [current]="disabled ? 0 : currentPage" (currentChange)="onChangePage($event)">
</twc-paginator>